import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING

// Only instantiate the SDK when a valid connection string is present.
// Instantiating with an empty string causes the SDK to monkey-patch fetch
// even though telemetry can never be sent, which interferes with MSAL.
let _appInsights: ApplicationInsights | null = null

export function getAppInsights() {
  return _appInsights
}

/**
 * Call once after msalInstance.initialize() resolves.
 * No-ops if the connection string is not configured.
 */
export function initAppInsights(userEmail?: string) {
  if (!connectionString) return

  try {
    _appInsights = new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: true,
        disableFetchTracking: false,
        enableCorsCorrelation: true,
        correlationHeaderExcludedDomains: ['login.microsoftonline.com'],
      },
    })
    _appInsights.loadAppInsights()

    if (userEmail) {
      _appInsights.setAuthenticatedUserContext(userEmail)
    }
  } catch (err) {
    console.warn('[telemetry] App Insights init failed:', err)
  }
}
